import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Box, IconButton, Link, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Theme } from "@mui/material/styles";
interface IDetailsCellProperties {
  details: {
    email: string;
    linkedinUrl: string;
    name: string;
  };
  handleCopyEmail: (email: string) => void;
  theme: Theme;
}

const DetailsCell = ({ details, handleCopyEmail, theme }: IDetailsCellProperties) => (
  <Box alignItems="center" display="block" gap={1}>
    <Box alignItems="center" display="flex" gap={1}>
      {details.linkedinUrl ? (
        <Link href={details.linkedinUrl} rel="noopener noreferrer" target="_blank">
          <IconButton size="small" sx={{ height: 24, padding: 0, width: 24 }}>
            <LinkedInIcon
              style={{
                color: theme.palette.info.main,
                fontSize: 12,
                height: 16,
                width: 16,
              }}
            />
          </IconButton>
        </Link>
      ) : (
        <IconButton disabled size="small" sx={{ height: 24, padding: 0, width: 24 }}>
          <LinkedInIcon
            style={{
              color: grey[500], // Grey color for non-clickable icon
              fontSize: 12,
              height: 16,
              width: 16,
            }}
          />
        </IconButton>
      )}
      <Typography sx={{ color: theme.palette.text.primary, fontSize: 12 }}>{details.name}</Typography>
    </Box>
    <Box alignItems="center" display="flex" gap={1}>
      <IconButton
        onClick={() => handleCopyEmail(details.email)}
        size="small"
        sx={{
          height: 24,
          padding: 0,
          width: 24,
        }}
      >
        <ContentCopyIcon
          sx={{
            "&:hover": {
              color: theme.palette.info.main,
            },
            color: theme.palette.text.secondary,
            fontSize: 12,
            height: 16,
            width: 16,
          }}
        />
      </IconButton>
      <Typography sx={{ color: grey[700], fontSize: 12 }}>{details.email}</Typography>
    </Box>
  </Box>
);

export default DetailsCell;
